// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__Q5LM7","page":"styles_page__EI8gW styles_default__Q5LM7","card":"styles_card__yVUmb styles_default__Q5LM7"};